<template>

    <div>
        <h3 class="weather-title-tag">{{ $t('menu.weather_and_crop_forecast') }}</h3>
        <b-btn class="btn-collapse-tips" variant="outline-warning" @click="showCollapse = !showCollapse">
            {{ ( showCollapse ? $t('menu.hide') : $t('menu.show') ) }}
        </b-btn>

        
        <div class="collapse-tips-area">
            <b-collapse id="map-control-tips" v-model="showCollapse">

                <div v-if="weather_data" class="proj-toolbox-area">
                    
                    <div class="powered">powered by <a href="https://www.cwb.gov.tw" target="blank">Central Weather Bureau</a></div>
                    
                    <div class="tab-style-management" v-if="reginData != undefined">
                        <b-tabs v-model="tabIndex" class="info-tabs" content-class="info-tab-content">

                            <!-- 地區資訊 -->
                            <b-tab class="info-tab" v-for="(regin, key, idx_re) in reginData" :key="idx_re" :title="key" @click="selected_regin = regin"></b-tab>

                        </b-tabs>
                    </div>

                    <div v-if="selected_regin" class="weather-card">
                        <!-- <div>{{ selected_regin.name }}</div> -->
                        <div class="weather-card-body">
                            <b-row align-v="center">
                                <b-col class="week-weather-block" cols="12">
                                    <div v-for="(dateWeather, dateKey, idx_date) in selected_regin.weatherElements" :key="idx_date" class="week-weather-sub-block">

                                        <div class="weatherWeekTitle">
                                            <div v-if="weathericon_type == 'fontawsome'">
                                                <i :class="'weather-icon ' + mapping_CWB_code_to_icon(dateWeather.weatherid, 'fontawsome-weather-icon')"></i>
                                            </div>
                                            <div v-else>
                                                <img class="weather-icon" :src="dateWeather.weathericon">
                                            </div>
                                            {{ dateWeather.degreeDay }}&deg;C
                                        </div>
                                        <div class="weatherWeekBody">
                                            <div>{{ dateKey }}</div>
                                            <div>{{ dateWeather.weather }}</div>
                                            <div><span>{{ $t('n.accumulatedTemperature') }}</span>: {{ dateWeather.accumulatedTemperature }}&deg;C</div>
                                            <div>{{ dateWeather.MinT }}&deg;C - {{ dateWeather.MaxT }}&deg;C</div>
                                        </div>
                                        
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </div>

                    <p>{{ weather_data.weatherProfile }}</p>
                    
                    <b-alert variant="warning" show>
                        <div v-for="(remark, idx_remark) in weather_data.remark" :key="idx_remark">
                            {{ remark }}
                        </div>
                    </b-alert>
                </div>
                <div v-else class="proj-toolbox-area">
                    <NoData></NoData>
                </div>

            </b-collapse>
        </div>

    </div>
</template>

<script>
import NoData from '@/views/components/NoData'

export default {
    props: {
        weather_data: {
            type: Object,
            required: true,
        },
        default_showCollapse: {
            type: Boolean,
            default: true,
        },
        weathericon_type: {
            type: String,
            default: 'fontawsome', // cwb
        },
    },
    components: {
        NoData,
    },
    data () {
        return {
            showCollapse: false,
            tabIndex: undefined,
            reginData: {},
            selected_regin: undefined,

            // document：
            // 中央氣象局 天氣敘述與圖示編號對應表： https://opendata.cwb.gov.tw/opendatadoc/MFC/A0012-001.pdf
            // 中央氣象局 天氣圖示列表： https://www.cwb.gov.tw/V8/C/K/Weather_Icon.html
            cwb_icon_url: 'cwb/', // 'https://www.cwb.gov.tw/V8/assets/img/weather_icons/weathers/svg_icon/day/',
        }
    },
    mounted () {
        // console.log( this.weather_data )
        this.arrange_reginData()
        this.showCollapse = this.default_showCollapse
    },
    computed: {

    },
    methods: {

        arrange_reginData ()
        {
            this.reginData = {}
            if (this.weather_data)
            {
                // 根據地區填入每日溫度 & 積溫
                if (this.weather_data.agrAdvices.agrForecasts && this.weather_data.agrAdvices.agrForecasts.location.length > 0)
                {
                    this.weather_data.agrAdvices.agrForecasts.location.forEach( _location => {

                        if ( this.reginData[ _location.locationName ] == undefined ) this.reginData[ _location.locationName ] = { name: _location.locationName, weatherElements: {} }

                        let _weatherElements = this.reginData[ _location.locationName ].weatherElements
                        _location.weatherElements.daily.forEach( _date => {
                            if ( _weatherElements[ _date.dataDate ] == undefined ) _weatherElements[ _date.dataDate ] = {}

                            // 當日溫度
                            _weatherElements[ _date.dataDate ].degreeDay = _date.degreeDay
                            // 累積溫度
                            _weatherElements[ _date.dataDate ].accumulatedTemperature = _date.accumulatedTemperature
                        })
                        

                    })
                }

                // 根據地區填入每日天氣描述 & 天氣 id ( Wx )、最高溫 ( MaxT )、最低溫 ( MinT )、
                if (this.weather_data.weatherForecasts && this.weather_data.weatherForecasts.location.length > 0)
                {
                    this.weather_data.weatherForecasts.location.forEach( _location => {

                        if ( this.reginData[ _location.locationName ] == undefined ) this.reginData[ _location.locationName ] = { name: _location.locationName, weatherElements: {} }

                        let _weatherElements = this.reginData[ _location.locationName ].weatherElements
                        _location.weatherElements.Wx.daily.forEach( _date => {
                            if ( _weatherElements[ _date.dataDate ] == undefined ) _weatherElements[ _date.dataDate ] = {}

                            // 天氣描述
                            _weatherElements[ _date.dataDate ].weather = _date.weather

                            // 天氣id
                            if (_date.weatherid < 10) _weatherElements[ _date.dataDate ].weatherid = '0' + _date.weatherid
                            else _weatherElements[ _date.dataDate ].weatherid = _date.weatherid

                            // 天氣 icon
                            _weatherElements[ _date.dataDate ].weathericon = this.cwb_icon_url + _weatherElements[ _date.dataDate ].weatherid + '.svg'
                        })
                        _location.weatherElements.MaxT.daily.forEach( _date => {
                            if ( _weatherElements[ _date.dataDate ] == undefined ) _weatherElements[ _date.dataDate ] = {}

                            // 當日最高溫
                            _weatherElements[ _date.dataDate ].MaxT = _date.temperature
                        })
                        _location.weatherElements.MinT.daily.forEach( _date => {
                            if ( _weatherElements[ _date.dataDate ] == undefined ) _weatherElements[ _date.dataDate ] = {}
                            
                            // 當日最低溫
                            _weatherElements[ _date.dataDate ].MinT = _date.temperature
                        })
                        

                    })
                }
                this.tabIndex = 1
                this.selected_regin = this.reginData[ '北部地區' ]
            }
        },

        mapping_CWB_code_to_icon (CWB_ID, Icon_Type)
        {
            if ( Icon_Type == 'fontawsome-weather-icon' )
            {
                switch (CWB_ID)
                {
                    case '01': return 'wi wi-day-sunny';
                    case '02': return 'wi wi-day-sunny-overcast';
                    case '03': return 'wi wi-day-cloudy';
                    case '04': return 'wi wi-day-cloudy';
                    case '05': return 'wi wi-cloudy';
                    case '06': return 'wi wi-cloudy';
                    case '07': return 'wi wi-cloud';
                    case '08': return 'wi wi-day-showers';
                    case '09': return 'wi wi-showers';
                    case '10': return 'wi wi-showers';
                    case '11': return 'wi wi-rain';
                    case '12': return 'wi wi-rain';
                    case '13': return 'wi wi-rain';
                    case '14': return 'wi wi-rain';
                    case '15': return 'wi wi-storm-showers';
                    case '16': return 'wi wi-storm-showers';
                    case '17': return 'wi wi-storm-showers';
                    case '18': return 'wi wi-thunderstorm';
                    case '19': return 'wi wi-day-showers';
                    case '20': return 'wi wi-day-showers';
                    case '21': return 'wi wi-day-storm-showers';
                    case '22': return 'wi wi-day-storm-showers';
                    case '23': return 'wi wi-rain-mix';
                    case '24': return 'wi wi-day-fog';
                    case '25': return 'wi wi-day-fog';
                    case '26': return 'wi wi-day-fog';
                    case '27': return 'wi wi-day-fog';
                    case '28': return 'wi wi-fog';
                    case '29': return 'wi wi-day-sprinkle';
                    case '30': return 'wi wi-sprinkle';
                    case '31': return 'wi wi-day-sprinkle';
                    case '32': return 'wi wi-sprinkle';
                    case '33': return 'wi wi-storm-showers';
                    case '34': return 'wi wi-storm-showers';
                    case '35': return 'wi wi-storm-showers';
                    case '36': return 'wi wi-storm-showers';
                    case '37': return 'wi wi-rain-mix';
                    case '38': return 'wi wi-showers';
                    case '39': return 'wi wi-rain';
                    case '40': return 'wi wi-rain';
                    case '41': return 'wi wi-rain';
                    case '42': return 'wi wi-snow';
                    default: return CWB_ID;
                }
            }

            return CWB_ID
        },

    }
}
</script>

<style lang="scss" scoped>

.alert
{
    margin: 5px;
}

p
{
    margin: 10px;
}
.proj-toolbox-area
{
    background-color: rgba(255, 255, 255, 0.7);
}


$color-orange: #e64d00;
$color-pink:   #ba1255;
$color-good:   #1f6140;
$color-leaf:   #258e25;
$color-leaf2:  #8bcc8b;
$color-wind:   #33cc33;
$color-blue:   #0086b3;
$color-blue2:  #41e7f3;
$color-blue3:  #42abdc;
$color-blue4:  #126e83;

.weather-title-tag
{
    display: inline-block;
    font-size: 1.3rem;
    padding: 6px 13px;
    margin-top: 10px;
    margin-bottom: -5px;
    margin-right: 5px;
    color: #106651;
    background-color: #b8da8c;
    border-radius: 5px;
    // transform: rotate(-4deg);
}

.powered
{
    float: right;
    font-size: 0.7rem;
    color: #8b7c99;
    margin-top: -5px;
}

.text-block
{
    display: inline-block;
    margin-right: 5px;
}

.weather-card
{
    width: 100%;
    padding: 5px 20px 5px 15px;
    margin: 0px;
    margin-top: -15px;
    border-radius: 10px;
    // background-color: #ececec; //#323332;

    .wi-sunrise    { color: #c79b09; } //#f0e43d;
    .wi-sunset     { color: #8b5134; } //#916a57;
}
.weather-card-title
{
    margin: 10px 20px 0px 20px;
    color: #3f6e5b;//#179c65;
    font-size: 1.1rem;
    text-align: left;
}
.weather-card-body
{
    border-radius: 0px 0px 10px 10px;
    color: #316c54; //$color-leaf2;
    text-align: center;
}

.current-weather-block
{
    display: inline-block;
    //margin: 5px;
}
.weather-block-left
{
    display: inline-block;
    vertical-align: middle;
    margin-left: 5px;
    margin-right: 5px;
    font-size: 4.5rem;
    line-height: 1.2;

    @media (max-width: 767px)
    {
        font-size: 3.5rem;
    }
    @media (max-width: 400px)
    {
        font-size: 2.5rem;
        margin-top: 5px;
    }
}
.weather-block-right
{
    display: inline-block;
    vertical-align: middle;
    font-size: 1.3rem;
    margin-top: 5px;
    margin-bottom: 10px;
}
.weather-info
{
    display: inline-block;
    font-size: 1.0rem;
    margin-top: 5px;
    margin-right: 5px;
    margin-left: 5px;

    //padding: 3px 13px;
    //border-radius: 20px;
    //color: #3e7e63;
    //background-color: #ebebeb;
}


// week weather
.week-weather-block
{
    display: inline-block;
    text-align: left;
    padding-top: 5px;
    color: #3e7e63;
    
    @media (max-width: 767px)
    {
        padding-top: 0px;
    }
}
.week-weather-sub-block
{
    display: inline-block;
    padding: 5px 5px;
    margin: 5px 0px;
    
    @media (min-width: 600px)
    {
        min-width: 250px;
    }
}

.weather-icon
{
    margin-top: 5px;
    max-width: 50px;
}

.weatherWeekTitle
{
    display: inline-block;
    vertical-align: top;
    text-align: center;
    font-size: 1.5rem;
    margin: 5px;
    margin-right: 10px;
    min-width: 45px;
}
.weatherWeekBody
{
    display: inline-block;
    text-align: left;
    font-size: 1.1rem;
}

@media (max-width: 400px)
{
    .week-weather-sub-block
    {
        min-width: 150px;
        margin-left: -15px;
    }
    .weatherWeekTitle
    {
        font-size: 1.2rem;
        min-width: 30px;
    }
}

</style>
